import React, {FC, ReactElement} from 'react';
import './index.scss'
import ArrowIcon from './arrow.svg';
import {IServiceItemProps} from "./type";
import {Popover} from "antd";
import {convertToArray, getLinkRow} from "mixins/helpers";

const ServiceGovItem: FC<IServiceItemProps> = (props: IServiceItemProps) => {
    const getLinks = (links: any[]): ReactElement => {
        let node = null;

        links.forEach(x => {
            node = getLinkRow(x.title, x.link, node)
        });

        return node;
    };

    return (
        <Popover placement="bottomRight" content={getLinks(convertToArray(props.links))}>
            <div className="service-link">
                <div>{ props.name }</div>

                <div>
                    <ArrowIcon />
                </div>
            </div>
        </Popover>
    )
};

export default ServiceGovItem;
